import { defineMessages } from 'react-intl';

export default defineMessages({
  warningText: {
    id: 'kustomer.chat.offlineWarning',
    description: 'Warning for poor network connection',
    defaultMessage: 'You are offline and may not be able to send or receive messages',
  },
});
